import { Directive, HostBinding, Inject, Optional } from '@angular/core';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { UiComponent } from '@df/ui/ui.component';
import { NPwa } from '../pwa.interface';
import { PwaA2hsService } from './pwa-a2hs.service';

export const PWA_A2HS_MODAL_ID = 'pwa-a2hs';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class PwaA2hsComponentDef<
    // block content
    C = any,
    D = any
> extends UiComponent {
    @HostBinding('class._is-ios')
    get isIos(): boolean {
        return this.pwaA2hsService.modalPlatform === NPwa.EPlatform.IOS;
    }

    readonly EPlatform = NPwa.EPlatform;

    constructor(
        protected pwaA2hsService: PwaA2hsService,
        @Optional() protected modalRef: ModalRef<C>,
        @Optional() @Inject(MODAL_DATA) public data: D
    ) {
        super();
    }

    get modalPlatform(): NPwa.EPlatform | undefined {
        return this.pwaA2hsService.modalPlatform;
    }

    addToHomeScreen(): void {
        if (this.modalPlatform === NPwa.EPlatform.ANDROID) {
            this.pwaA2hsService.preventPrompt = false;

            this.pwaA2hsService.deferredPrompt.value!.prompt();
        }
    }

    modalClose(): void {
        this.pwaA2hsService.modalClose();
    }
}
